<div class="edit-building" *ngIf="isModalVisible$ | async">
  <button type="button" class="close-modal" (click)="close()"></button>
  <div class="description-object-type">
    <div class="top-part">
      <label class="category">
        {{ 'module.energyMap.descriptionComponent.editBuildingDetailsText' | translate }}
      </label>
      <div>
        <div class="building-details">
          <div class="address-section building-detail">
            <div class="identifier">{{ 'module.energyMap.descriptionComponent.address' | translate }}</div>
            <div class="value">
              <div>{{ (selectedBuilding | async).marker.options.data | getAddress }}</div>
            </div>
          </div>
          <div class="building-meters building-detail">
            <div class="identifier">Zählernummer</div>
            <div class="value" *ngFor="let meter of (selectedBuilding | async)?.marker.options.data.meters; trackBy: trackByFn">
              {{ meter.meterNumber }}
            </div>
          </div>
        </div>
      </div>

      <div class="description-types" *ngIf="(visiblePage$ | async) === 'notype'">
        <div class="identifier">Objekttyp</div>
        <div class="btn-group" dropdown>
          <mat-form-field class="dropdown-toggle" floatLabel="never">
            <mat-label>
              {{ selectedBuildingType ? selectedBuildingType?.name : ('module.energyMap.descriptionComponent.editBuildingDetailsText' | translate) }}
            </mat-label>
            <mat-select matNativeControl required [(ngModel)]="selectedBuildingType">
              <mat-option role="menuitem" *ngFor="let buildingType of buildingTypes" [value]="buildingType">
                {{ buildingType.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="validator" [ngClass]="selectedBuildingType?.name ? 'success' : 'error'">
          <span [ngClass]="selectedBuildingType?.name ? 'fa fa-check-circle' : ' fa fa-info-circle'"> </span>
          {{
            (selectedBuildingType?.name
              ? 'module.energyMap.descriptionComponent.objectTypeWithValueText'
              : 'module.energyMap.descriptionComponent.objectTypeNullText'
            ) | translate
          }}
        </div>
        <div class="action-btns-container">
          <div class="action-btns">
            <button class="btn btn-outline-primary" (click)="next()" [disabled]="selectedBuildingType == null">
              <span class="fa fa-arrow-right" aria-hidden="true"></span>
              <span class="btn-text">{{ 'module.energyMap.descriptionComponent.next' | translate }}</span>
            </button>
            <button class="btn btn-outline-secondary cancel-btn" (click)="close()">
              <span class="btn-text">{{ 'module.energyMap.descriptionComponent.cancel' | translate }}</span>
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="(visiblePage$ | async) === 'nogps'" class="description-gps">
        <label class="description-gps-label">
          {{ 'module.energyMap.descriptionComponent.gpsLocation' | translate }}
        </label>
        <div class="instructions">
          <div class="instruction-item">
            <div class="badge">
              <div class="badge-number">1</div>
            </div>
            <div class="gps-instruction">
              {{ 'module.energyMap.descriptionComponent.gpsInstruction1' | translate }}
            </div>
          </div>

          <div class="instruction-item">
            <div class="badge">
              <div class="badge-number">2</div>
            </div>
            <div class="gps-instruction">
              {{ 'module.energyMap.descriptionComponent.gpsInstruction2' | translate }}
            </div>
          </div>
          <div class="instruction-item">
            <div class="badge">
              <div class="badge-number">3</div>
            </div>
            <div class="gps-instruction">
              {{ 'module.energyMap.descriptionComponent.gpsInstruction3' | translate }}
            </div>
          </div>
          <div class="instruction-item">
            <div class="badge">
              <div class="badge-number">4</div>
            </div>
            <div class="gps-instruction">
              {{ 'module.energyMap.descriptionComponent.gpsInstruction4' | translate }}
            </div>
          </div>
          <div class="instruction-item">
            <div class="badge">
              <div class="badge-number">5</div>
            </div>
            <div class="gps-instruction">
              {{ 'module.energyMap.descriptionComponent.gpsInstruction5' | translate }}
            </div>
          </div>
        </div>
        <div class="object-location-container" *ngIf="!!authService.permissions.BUILDING_LOCATION_UPDATE">
          <button class="btn btn-primary" *ngIf="selectedBuilding | async as building" (click)="localizeObject(building)">
            <span class="fa fa-map-marker" aria-hidden="true"></span>
            <span class="btn-text">{{ 'module.energyMap.descriptionComponent.locateObject' | translate }}</span>
          </button>
        </div>

        <div class="comments">
          <div class="identifier">Kommentar</div>
          <textarea
            class="description-input textarea-comment"
            rows="3"
            cols="50"
            maxlength="250"
            *ngIf="selectedBuilding | async as building"
            [(ngModel)]="building.marker.options.data.description"
          ></textarea>
        </div>
        <div class="action-btns-container">
          <button class="btn back-btn" *ngIf="selectedBuilding | async as building" (click)="back(building)">
            <span class="fa fa-arrow-left" aria-hidden="true"></span>
            <span class="btn-text">Zurück</span>
          </button>
          <div class="action-btns">
            <button
              class="btn btn-outline-primary"
              *ngIf="selectedBuilding | async as building"
              (click)="save(building)"
              [class.-disabled]="this.marker == null"
              [disabled]="this.marker == null"
            >
              <span class="fa fa-save" aria-hidden="true"></span>
              <span class="btn-text">Speichern</span>
            </button>
            <button (click)="close()" class="btn btn-outline-secondary cancel-btn">
              <span class="btn-text">Abbrechen</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
